import React, { useEffect, useRef } from 'react';
import 'intersection-observer';
import { useLocation } from "react-router-dom";
import usePrev from "hook/usePrev";
function LazyImage(_a) {
    var dataSrc = _a.dataSrc, defaultImage = _a.defaultImage, className = _a.className, noScriptSrc = _a.noScriptSrc, alt = _a.alt, value = _a.value;
    var imgRef = useRef(null);
    var location = useLocation();
    var prevKey = usePrev(value || location.key);
    useEffect(function () {
        if ((value !== prevKey || location.key !== prevKey) && (imgRef.current.src !== defaultImage)) {
            imgRef.current.src = defaultImage;
        }
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var isIntersecting = entry.isIntersecting;
                if (isIntersecting && imgRef.current.dataset && imgRef.current.dataset.src) {
                    imgRef.current.src = imgRef.current.dataset.src;
                    observer.disconnect();
                }
            });
        }, {
            rootMargin: "0px 0px 200px 0px"
        });
        observer.observe(imgRef.current);
    }, [location.key, value]);
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { ref: imgRef, "data-src": dataSrc, src: defaultImage, className: className, alt: alt, loading: 'lazy' }),
        React.createElement("noscript", null,
            React.createElement("img", { src: noScriptSrc, className: className, alt: alt, loading: 'lazy' }))));
}
export default LazyImage;
